import { default as axios } from '../utils/axios.instances' // eslint-disable-line

const axiosInstance = axios.getSTAxios() // eslint-disable-line

export default {

  async getATPConfiguration () {
    return new Promise((resolve, reject) => {
      axiosInstance.get('/atp/config/').then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  async updateATPConfiguration (accountId) {
    return new Promise((resolve, reject) => {
      axiosInstance.patch('/atp/config/', { account_id: accountId, is_enabled: true }).then((res) => {
        resolve(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

}
